import React, {useEffect, useState} from 'react';
import {
    Page,
    Text,
    View,
    Image,
    Document,
    StyleSheet
} from '@react-pdf/renderer';
import Logo from '../kirisun-americas-logo.png';

const pngImage = 'data:image/png;base64,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';


const RmaPdf = ({rma, address, barcode}) => {

    const [barcodeURI, setBarcodeURI] = useState(null);

    const [styles] = useState(
        {
            page: {
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#FFFFFF',
                paddingTop: 35,
                paddingBottom: 65,
                paddingHorizontal: 35
            },
            section: {
                margin: 10,
                padding: 10,
            },
            row: {
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'stretch',
                justifyContent: 'space-between',
                //width: '100%',
                //border: '1px solid red'
            },
            col: {
                display: 'flex',
                flexDirection: 'column',
                //flexGrow: 1,
                //border: '1px solid blue'
            },
            pageNumber: {
                position: 'absolute',
                fontSize: 12,
                bottom: 30,
                left: 0,
                right: 0,
                textAlign: 'center',
                color: 'grey',
            },
            text: {
                fontSize: 10
            },
        }
    );

    useEffect(() => {

      if (barcode) { 
        console.log('barcode', barcode);

        const image = document.createElement('img');
        image.src = barcode; 
        image.width = 209;
        image.height = 72;

        const canvas = document.createElement('canvas');
        canvas.width = 209;
        canvas.height = 72;
        const ctx = canvas.getContext('2d');
        ctx.beginPath();
        ctx.strokeStyle = 'red';
        ctx.drawImage(image, 0, 0); console.info('image.namespaceURI', image.namespaceURI); console.info('image.baseURI', image.baseURI);
        ctx.moveTo(0,0);
        ctx.lineTo(canvas.width, canvas.height);
        ctx.stroke();
        ctx.closePath();

        const imgPngSrc = canvas.toDataURL(); console.log('barcodeURI', imgPngSrc);
        setBarcodeURI(imgPngSrc);
      }
      

    }, []);

    return (
      <Document
        title={rma.rmano}
        author={rma.filedby}
        subject="Return Material Authorization Form"
        keywords="RMA"
        language="ENG"
      >
        <Page size="LETTER" style={styles.page}>
          <View style={styles.row}>

            <View style={styles.col}>
              <Image src={Logo} style={{ width: 130, height: 30 }} />
            </View>

            <View style={styles.col}>
              {barcode && <Image src={`${barcodeURI}`} debug style={{width: 209, height: 72}}/> }
              {/* <Image src={pngImage} debug style={{width: 209, height: 72}}/>  */}
            </View>

            <View style={styles.col}>
              <Text
                style={[
                  styles.row,
                  { alignSelf: "flex-end", fontSize: 24, fontWeight: "bold" },
                ]}
              >
                RMA
              </Text>

              <Text
                style={[styles.row, { alignSelf: "flex-end", fontSize: 12 }]}
              >
                {rma.rmano}
              </Text>
            </View>

          </View>

          <View style={[styles.row, { marginTop: 12 }]}>
            <Text style={[styles.col, styles.text]}>
              Entered by: {rma.filedby}
            </Text>
            <Text style={[styles.col, styles.text, { textAlign: "right" }]}>
              Ref. PO/Inv: {rma.poref}
            </Text>
          </View>

          <Text style={[styles.text, { marginTop: 20 }]}>
            A.CUSTOMER INFORMATION
          </Text>
          <View
            style={[styles.col, { width: "100%", border: "1px solid black" }]}
          >
            <View
              style={[
                styles.row,
                { padding: 10, justifyContent: "space-around" },
              ]}
            >
              <View style={styles.col}>
                <Text style={[styles.text]}>Return To:</Text>
                <Text style={styles.text}>Kirisun Americas</Text>
                <Text style={styles.text}>6073 NW 167th ST. Unit C28</Text>
                <Text style={styles.text}>Miami, FL, 33015, USA</Text>
                <Text style={styles.text}>Phone: +1 (786) 359-4933</Text>
                <Text style={styles.text}>admin@kirisunamericas.com</Text>
              </View>

              <View style={styles.col}>
                <Text style={[styles.text]}>Ship To:</Text>
                <Text style={styles.text}>{address.name}</Text>
                <Text style={styles.text}>{address.address}</Text>
                <Text style={styles.text}>{address.city},{address.state},{address.zip}</Text>
                <Text style={styles.text}>{address.country}</Text>
              </View>
            </View>

            <View style={[styles.col, { padding: 10 }]}>
              <Text style={[styles.text]}>Comments:</Text>
              <Text style={[styles.text]}>{rma.comments}</Text>
            </View>
          </View>

          <Text style={[styles.text, { marginTop: 20 }]}>
            B.PRODUCT INFORMATION
          </Text>
          <View
            style={[styles.col, { width: "100%", border: "1px solid black" }]}
          >
            <View style={styles.row}>
              <Text style={[styles.text, { width: "10%" }]}>Product</Text>
              <Text style={[styles.text, { width: "18%" }]}>Serial No.</Text>
              <Text style={[styles.text, { width: "7%" }]}>FW/SW</Text>
              <Text style={[styles.text, { width: "60%" }]}>
                Reason for return
              </Text>
              <Text style={[styles.text, { width: "5%" }]}>DOA</Text>
            </View>

            {rma.products.map((product, i) => {
              return (
                <View
                  key={i}
                  style={[
                    styles.row,
                    {
                      paddingTop: 3,
                      paddingBottom: 3,
                      borderTop: "1px solid black",
                    },
                  ]}
                >
                  <Text style={[styles.text, { width: "10%" }]}>
                    {product.product}
                  </Text>
                  <Text style={[styles.text, { width: "18%" }]}>
                    {product.sn}
                  </Text>
                  <Text style={[styles.text, { width: "7%" }]}>
                    {product.fwswver}
                  </Text>
                  <Text style={[styles.text, { width: "60%" }]}>
                    {product.reason}
                  </Text>
                  <Text
                    style={[styles.text, { width: "5%", textAlign: "center" }]}
                  >
                    {product.doa ? "X" : "_"}
                  </Text>
                </View>
              );
            })}
          </View>

          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </Page>
      </Document>
    );
}

export default RmaPdf;